import React from 'react';
export function Footer() {
  return <footer className="w-full bg-navy-mid border-t border-white/5 py-12 px-6" data-id="element-66">
      <div className="max-w-6xl mx-auto" data-id="element-67">
        <div className="flex flex-col md:flex-row items-center md:items-start justify-between gap-8" data-id="element-68">
          {/* Logo & address */}
          <div className="text-center md:text-left" data-id="element-69">
            <span className="font-display font-bold text-xl bg-gradient-to-r from-coral to-coral-light bg-clip-text text-transparent" data-id="element-70">
              Viveludique
            </span>
            <p className="font-body text-slate-500 text-sm mt-2" data-id="element-71">
              Limassol, Cyprus
            </p>
          </div>

          {/* Nav links */}
          <nav aria-label="Footer navigation" className="flex items-center gap-6" data-id="element-72">
            <a href="#problems" className="font-body text-slate-400 text-sm hover:text-coral transition-colors duration-200" data-id="element-73">
              Problems
            </a>
            <a href="#solution" className="font-body text-slate-400 text-sm hover:text-coral transition-colors duration-200" data-id="element-74">
              Solution
            </a>
            <a href="#features" className="font-body text-slate-400 text-sm hover:text-coral transition-colors duration-200" data-id="element-75">
              Features
            </a>
            <a href="#pricing" className="font-body text-slate-400 text-sm hover:text-coral transition-colors duration-200" data-id="element-76">
              Pricing
            </a>
          </nav>
        </div>

        {/* Divider */}
        <div className="border-t border-white/5 mt-8 pt-8" data-id="element-77">
          <p className="font-body text-slate-600 text-xs text-center" data-id="element-78">
            © 2026 Viveludique. All rights reserved.
          </p>
        </div>
      </div>
    </footer>;
}